import axios from "axios";

/* =====================================================================
   Shared GET
   =====================================================================
   The header (live counts) and the home page's sport list both load
   matchapi / footballapi / tennisapi as they mount, so every home visit
   asked for each list twice (#10). Identical GETs issued within a few
   seconds of each other now share one request and one response.

   Short-lived on purpose: this collapses simultaneous mounts, it is not
   a cache -- odds are live, and the next poll must reach the server.
   ===================================================================== */

const WINDOW_MS = 5000;
const entries = new Map(); // url -> { at, promise }

export const sharedGet = (url, config) => {
  const now = Date.now();
  const hit = entries.get(url);
  if (hit && now - hit.at < WINDOW_MS) return hit.promise;

  const promise = axios.get(url, config);
  entries.set(url, { at: now, promise });
  // A failed request must not be handed to the next caller.
  promise.catch(() => {
    if (entries.get(url)?.promise === promise) entries.delete(url);
  });
  return promise;
};

/* Same for the read-only POST the header and the home list both make for
   market prices (getMarkets): keyed by URL and body, so it only collapses
   requests that would have returned the same thing. */
export const sharedPost = (url, body) => {
  const key = `POST ${url} ${JSON.stringify(body)}`;
  const now = Date.now();
  const hit = entries.get(key);
  if (hit && now - hit.at < WINDOW_MS) return hit.promise;

  const promise = axios.post(url, body);
  entries.set(key, { at: now, promise });
  promise.catch(() => {
    if (entries.get(key)?.promise === promise) entries.delete(key);
  });
  return promise;
};

export default sharedGet;
